<p-toast></p-toast>
<router-outlet />
<app-unsaved-changes-dialog></app-unsaved-changes-dialog>
<app-global-loading></app-global-loading>
<app-upload-progress-badge></app-upload-progress-badge>
